import React from 'react'
import {
  Container,
  TextTitle,
  BlockingLoader,
  Tools,
  TextCaption
} from '@pmi/pmi-iqos-ds-react'
import { Price } from '@pmi/pmi-iqos-shared-react'
import { ProductItem } from '@zyn-common/components'

const CartItem = ({
  translations,
  index,
  amount,
  item,
  noDetailLink,
  showFamily,
  handleQuantitySelectionChange,
  handleOptionSelectionChange,
  handleRemoveFromCart
}) => {
  const lastIndex = amount - 1

  const ChainPrice = ({ children }) => {
    return Tools.isDesktop() ? (
      <TextTitle heading={TextTitle.headings.h5}>{children}</TextTitle>
    ) : (
      <TextCaption size={TextCaption.sizes.m}>{children}</TextCaption>
    )
  }
  return (
    <Container
      divider={[
        index === 0
          ? Container.dividers.y
          : index !== lastIndex
          ? Container.dividers.bottom
          : null,
        index !== lastIndex ? Container.dividers.bottom : null
      ]}
      pt={['8', '10']}
      position={Container.positions.relative}>
      <BlockingLoader loading={item.loading} zIndex="3" />
      {item.chainId && (
        <Container
          display={Container.displays.flex}
          justifyContent={Container.justifyContentValues.between}
          pb="4">
          {item.chainName && (
            <TextTitle
              heading={TextTitle.headings.h5}
              data-testing="Cart_TextTitle_BundleName">
              {item.chainName}
            </TextTitle>
          )}
          {item.chainPrice && (
            <Container pl="4">
              <ChainPrice>
                <Price
                  size=""
                  listPrice={item.chainPrice}
                  price={
                    item.chainPriceDisplayDiscount &&
                    Number(item.chainPriceDiscountValue) !==
                      Number(item.chainPrice)
                      ? item.chainPriceDiscountValue
                      : item.chainPrice
                  }
                  listPriceLabel={translations.tk_listPriceDescription}
                  priceAlignmentDisplay={Price.displays.block}
                  data-testing="Cart_TextTitle_BundlePrice"
                />
              </ChainPrice>
            </Container>
          )}
        </Container>
      )}
      {item.products.map(product => {
        return (
          !product.isLogistics && (
            <ProductItem
              translations={translations}
              key={product.itemId}
              item={product}
              onQuantityChange={handleQuantitySelectionChange}
              onOptionChange={handleOptionSelectionChange}
              onRemoveItem={handleRemoveFromCart}
              noDetailLink={noDetailLink}
              showFamily={showFamily}
            />
          )
        )
      })}
    </Container>
  )
}

export default CartItem
